import FilterPill from './filter-pill';
import PreviewYourRatesDrawerDialog, {
  PreviewYourRatesDrawerDialogProps,
} from './preview-your-rates-drawer-dialog';
import FilterCreditAgePillCopy from './filters/filter-credit-age-pill-copy';

interface FilterCreditDrawerDialogProps
  extends Omit<PreviewYourRatesDrawerDialogProps, 'trigger'> {
  handleOpen: () => void;
  error?: string;
  pillClassName?: string;
  dark?: boolean;
  forceShorthandCopy?: boolean;
}

export default function FilterCreditDrawerDialog({
  selectedCreditScoreId,
  selectedIsOver25,
  selectedAgeRangeId,
  creditScores,
  ageRanges,
  error,
  open,
  handleOpen,
  handleClose,
  pillClassName,
  dark,
  forceShorthandCopy,
}: FilterCreditDrawerDialogProps) {
  return (
    <>
      <FilterPill
        onClick={handleOpen}
        text={
          <FilterCreditAgePillCopy
            creditScores={creditScores}
            selectedCreditScoreId={selectedCreditScoreId}
            ageRanges={ageRanges}
            selectedAgeRangeId={selectedAgeRangeId}
            forceShorthandCopy={forceShorthandCopy}
            dark={dark}
          />
        }
        className={pillClassName}
        dark={dark}
      />
      <PreviewYourRatesDrawerDialog
        selectedCreditScoreId={selectedCreditScoreId}
        selectedIsOver25={selectedIsOver25}
        selectedAgeRangeId={selectedAgeRangeId}
        creditScores={creditScores}
        ageRanges={ageRanges}
        error={error}
        open={open}
        handleClose={handleClose}
        // This key will force the dialog to remount on key change so that credit and age updates from FSC are reflected here too
        key={`preview-your-rates-drawer-dialog-${selectedCreditScoreId}-${selectedIsOver25}`}
      />
    </>
  );
}
